import { render, staticRenderFns } from "./LocationFilter.vue?vue&type=template&id=0c4970db&scoped=true"
import script from "./LocationFilter.vue?vue&type=script&lang=ts"
export * from "./LocationFilter.vue?vue&type=script&lang=ts"
import style0 from "./LocationFilter.vue?vue&type=style&index=0&id=0c4970db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4970db",
  null
  
)

export default component.exports